<template>
  <span class="inline">
    <!-- <span
      v-on:mouseover="hover"
      v-on:mouseout="hoverOut"
      style="cursor: pointer"
      v-if="flag === 'envelope'"
    >
      <i class="fa fa-envelope"></i>
    </span> -->
    <span
      v-on:mouseover="hover"
      v-on:mouseout="hoverOut"
      style="cursor: pointer"
      v-if="flag =='share' && permissions.indexOf('EMAIL_REGISTRATION_SHARE') > -1"
    >
      <button type="button" class="btn btn-export" style="float: right;background: #fff;">
        <img src="/static/images/icons/icon_share.svg" style="height: 18px;width: 18px;" /> Share
      </button>
    </span>
    <div
      style="text-align: center;font-weight: 400;top: -100px;left: -50px;"
      class="email-popover"
      v-if="showPopup && flag =='envelope' && mode == '1'"
      transition="fade"
      v-on:mouseover="hoverInfo"
      v-on:mouseout="hoverOutInfo"
    >
      <div style="padding: 5px 0px;cursor: pointer;" @click="emailRegistrationDetails">
        <img src="/static/images/icons/icon_email.svg" style="height: 18px;width: 18px;" />
        <span class="email-hover">Email registration details</span>
      </div>
      <div style="padding: 5px 0px;cursor: pointer;" @click="emailRegistrationLink">
        <img src="/static/images/icons/icon_link.svg" style="height: 18px;width: 18px;" />
        <span class="email-hover">Email link to registration</span>
      </div>
    </div>

    <div
      class="share-popover text-bold-blue"
      style="text-align: center;font-weight: 400;top: -90px;right: 15px;"
      v-if="showPopup && flag =='share' && mode == '1'"
      transition="fade"
      v-on:mouseover="hoverInfo"
      v-on:mouseout="hoverOutInfo"
    >
      <div style="padding: 5px 0px;cursor: pointer;" @click="emailRegistrationDetails">
        <img src="/static/images/icons/icon_email.svg" style="height: 18px;width: 18px;" />
        <span class="email-hover">Email registration details</span>
      </div>
      <div style="padding: 5px 0px;cursor: pointer;" @click="emailRegistrationLink">
        <img src="/static/images/icons/icon_link.svg" style="height: 18px;width: 18px;" />
        <span class="email-hover">Email link to registration</span>
      </div>
    </div>

    <div
      class="share-popover text-bold-blue"
      style="text-align: center;font-weight: 400;top: -90px;right: 15px;"
      v-if="showPopup && flag =='share' && mode == '2'"
      transition="fade"
      v-on:mouseover="hoverInfo"
      v-on:mouseout="hoverOutInfo"
    >
      <div style="padding: 5px 0px;cursor: pointer;" @click="emailRegistrationDetails">
        <img src="/static/images/icons/icon_email.svg" style="height: 18px;width: 18px;" />
        <span class="email-hover">Email certificate details</span>
      </div>
      <div style="padding: 5px 0px;cursor: pointer;" @click="emailRegistrationLink">
        <img src="/static/images/icons/icon_link.svg" style="height: 18px;width: 18px;" />
        <span class="email-hover">Email link to certificate</span>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  props: ['flag', 'mode', 'sendTo', 'id', 'permissions'],
  data() {
    return {
      showPopup: false,
      timer: '',
      isInInfo: false,
      status: 'Sunny',
      errors: [],
    };
  },
  methods: {
    emailRegistrationDetails() {
      const data = {
        mode: this.mode,
        id: this.id,
        sendTo: this.sendTo,
        isLink: false,
      };
      if (this.mode === '1') {
        this.$emit('openRegistrationEmailPopup', data);
      } else if (this.mode === '2') {
        this.$emit('openCertificateEmailPopup', data);
      }
    },

    emailRegistrationLink() {
      const data = {
        mode: this.mode,
        id: this.id,
        sendTo: this.sendTo,
        isLink: true,
      };
      if (this.mode === '1') {
        this.$emit('openRegistrationEmailPopup', data);
      } else if (this.mode === '2') {
        this.$emit('openCertificateEmailPopup', data);
      }
    },

    hover() {
      const vm = this;
      this.timer = setTimeout(() => {
        vm.showPopover();
      }, 400);
    },

    hoverOut() {
      const vm = this;
      clearTimeout(vm.timer);
      this.timer = setTimeout(() => {
        if (!vm.isInInfo) {
          vm.closePopover();
        }
      }, 200);
    },

    hoverInfo() {
      this.isInInfo = true;
    },

    hoverOutInfo() {
      this.isInInfo = false;
      this.hoverOut();
    },

    showPopover() {
      this.showPopup = true;
    },

    closePopover() {
      this.showPopup = false;
    },
  },
};
</script>
<style scoped>
.share-popover img{
  margin-right:5px;
}
</style>
